import { styled } from 'styled-components';

import * as api from '../../../../api';

import { Col, Row } from 'react-bootstrap';

import { ReactComponent as EmptyStar } from '../../../../assets/star-empty.svg';
import { ReactComponent as FilledStar } from '../../../../assets/star-filled.svg';
import { StyledTypography } from './';

const StarRating: React.FC<{
  ratingWithCount: api.PrevisitProvider.RatingWithCount;
}> = ({ ratingWithCount }) => {
  return (
    <Row className="ps-1">
      <Col xs="auto" className="ps-2 pe-0">
        <StarFill className="ps-0">{fillStars(ratingWithCount.value)}</StarFill>
        <StarOutline className="ps-0">
          {[...Array(5)].map((star, i) => {
            return <StyledEmptyStar key={i} />;
          })}
        </StarOutline>
      </Col>
      <Col className="ps-1">
        <StyledTypography
          variant="title-medium"
          className="pt-1 ps-1"
          color="var(--color-shade-70)"
        >
          {`${ratingWithCount.value.toFixed(1)} (${ratingWithCount.count})`}
        </StyledTypography>
      </Col>
    </Row>
  );
};

export default StarRating;

const fillStars = (rating: number) => {
  const fill = [...Array(Math.ceil(rating))].map((star, i) => {
    if (i === Math.floor(rating)) {
      const adjustedWidth = (rating - Math.floor(rating)) * 13;
      return <StyledFilledStar key={i} width={adjustedWidth} />;
    }
    return <StyledFilledStar key={i} />;
  });
  return fill;
};

const StarFill = styled.span`
  display: block;
  position: absolute;
  overflow: hidden;
  padding-top: 1px;
`;

const StarOutline = styled.span`
  display: block;
  width: 65px;
  padding-top: 1px;
`;

const StyledFilledStar = styled(FilledStar)`
  path {
    fill: var(--color-primary);
    stroke: var(--color-primary);
  }
`;

const StyledEmptyStar = styled(EmptyStar)`
  path {
    stroke: var(--color-primary);
  }
`;
